// extracted by mini-css-extract-plugin
module.exports = {"placeholderContainer":"Dropdown_placeholderContainer__2LPKu"};